var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	75862: () => (loadStrictSingletonVersion("default", "@angular/common", false, [1,20,1,5], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	3936: () => (loadStrictSingletonVersion("default", "@angular/core", false, [1,20,1,5], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_10e21").then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	76650: () => (loadStrictSingletonVersion("default", "@angular/router", false, [1,20,1,5], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a220").then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	5983: () => (loadSingletonVersion("default", "shared-utility-bidder", false, [1,0], () => (__webpack_require__.e("shared-utility-bidder_dist_shared-utility-bidder_fesm2022_shared-utility-bidder_mjs-_b3a90").then(() => (() => (__webpack_require__(/*! shared-utility-bidder */ 18311))))))),
	224: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [1,20,1,5], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9341").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	54376: () => (loadStrictSingletonVersion("default", "@angular/core/rxjs-interop", false, [1,20,1,5], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f0").then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))))),
	56288: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [1,20,1,5], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0").then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	47562: () => (loadStrictSingletonVersion("default", "@angular/core", false, [1,20,1,5], () => (__webpack_require__.e("shared-utility-bidder_node_modules_angular_core_fesm2022_core_mjs-_43e21").then(() => (() => (__webpack_require__(/*! @angular/core */ 51416))))))),
	692: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [1,20,1,5], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_signals_mjs-_22bb1").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	88706: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [1,20,1,5], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_di_mjs-_84d20").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))))),
	43828: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [1,20,1,5], () => (__webpack_require__.e("shared-utility-bidder_node_modules_angular_core_fesm2022_primitives_signals_mjs-_7bd11").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 96533))))))),
	69234: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [1,20,1,5], () => (__webpack_require__.e("shared-utility-bidder_node_modules_angular_core_fesm2022_primitives_di_mjs-_18221").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 9015))))))),
	49260: () => (loadStrictSingletonVersion("default", "@angular/common", false, [1,20,1,5], () => (__webpack_require__.e("shared-utility-bidder_node_modules_angular_common_fesm2022_common_mjs-_bb6a1").then(() => (() => (__webpack_require__(/*! @angular/common */ 28600))))))),
	98604: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [1,20,1,5], () => (__webpack_require__.e("shared-utility-bidder_node_modules_angular_common_fesm2022_http_mjs-_2ccd1").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 54367))))))),
	55848: () => (loadStrictSingletonVersion("default", "@angular/router", false, [1,20,1,5], () => (__webpack_require__.e("shared-utility-bidder_node_modules_angular_router_fesm2022_router_mjs-_57f81").then(() => (() => (__webpack_require__(/*! @angular/router */ 5708))))))),
	3370: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [1,20,1,5], () => (__webpack_require__.e("shared-utility-bidder_node_modules_angular_forms_fesm2022_forms_mjs-_8c0d1").then(() => (() => (__webpack_require__(/*! @angular/forms */ 8980)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"src_bootstrap_ts": [
		75862,
		3936,
		76650,
		5983,
		224,
		54376,
		56288
	],
	"shared-utility-bidder_node_modules_angular_common_fesm2022_http_mjs-_2ccd0": [
		47562
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		3936
	],
	"shared-utility-bidder_node_modules_angular_common_fesm2022_common_mjs-_bb6a0": [
		47562
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		3936
	],
	"node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f1": [
		692,
		88706
	],
	"shared-utility-bidder_node_modules_angular_core_fesm2022_core_mjs-_43e20": [
		43828,
		69234
	],
	"node_modules_angular_core_fesm2022_core_mjs-_10e20": [
		692,
		88706
	],
	"shared-utility-bidder_node_modules_angular_forms_fesm2022_forms_mjs-_8c0d0": [
		47562,
		49260
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1": [
		3936,
		75862
	],
	"shared-utility-bidder_node_modules_angular_router_fesm2022_router_mjs-_57f80": [
		47562,
		49260,
		98604
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a221": [
		75862,
		3936,
		224
	],
	"shared-utility-bidder_dist_shared-utility-bidder_fesm2022_shared-utility-bidder_mjs-_b3a91": [
		47562,
		98604,
		49260,
		55848,
		3370
	],
	"node_modules_angular_core_fesm2022_core_mjs-_10e21": [
		692,
		88706
	],
	"shared-utility-bidder_dist_shared-utility-bidder_fesm2022_shared-utility-bidder_mjs-_b3a90": [
		47562,
		98604,
		49260,
		55848,
		3370
	],
	"node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f0": [
		692,
		88706
	],
	"shared-utility-bidder_node_modules_angular_core_fesm2022_core_mjs-_43e21": [
		43828,
		69234
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}